import { render, staticRenderFns } from "./deleteGoldWithdrawal.vue?vue&type=template&id=6dd2216b"
import script from "./deleteGoldWithdrawal.vue?vue&type=script&lang=js"
export * from "./deleteGoldWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports